var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Modem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modem"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modem-2",
    "data-name": "Modem"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.8422,270.5905h-26.82V159.99H301.916V270.5905h-180.99a33.5534,33.5534,0,0,0-33.516,33.516v73.7419a33.5534,33.5534,0,0,0,33.516,33.516H348.8422a33.5534,33.5534,0,0,0,33.516-33.516V304.1065A33.5534,33.5534,0,0,0,348.8422,270.5905Zm13.4006,107.2579a13.4214,13.4214,0,0,1-13.4006,13.4054H120.9257a13.43,13.43,0,0,1-13.41-13.4054V304.1065a13.4274,13.4274,0,0,1,13.41-13.4055H348.8422a13.4191,13.4191,0,0,1,13.4006,13.4055Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3047,
    y: 330.9174,
    width: 22.902,
    height: 20.1106
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.7297,
    y: 330.9174,
    width: 22.9115,
    height: 20.1106
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.1642,
    y: 330.9174,
    width: 22.902,
    height: 20.1106
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.2537,227.48a79.6442,79.6442,0,0,1,0-112.6262L228.03,100.6356a99.7136,99.7136,0,0,0,.0095,141.0631Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.5374,221.1955l14.2146-14.2184a50.6411,50.6411,0,0,1,0-71.6151l-14.2146-14.2232a70.7484,70.7484,0,0,0,0,100.0567Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.99,199.7338l14.2242-14.2146a20.3073,20.3073,0,0,1,0-28.6993L269.99,142.6005a40.4308,40.4308,0,0,0,0,57.1333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.3758,100.6356l-14.2146,14.2185a79.65,79.65,0,0,1,0,112.631l14.2146,14.2136a99.7482,99.7482,0,0,0,0-141.0631Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.6437,206.9771l14.2337,14.2184a70.7506,70.7506,0,0,0,0-100.0567L360.6532,135.362a50.6065,50.6065,0,0,1-.01,71.6151Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4061,199.7338a40.4008,40.4008,0,0,0,.0182-57.1285l-14.2328,14.21a20.29,20.29,0,0,1,0,28.7041Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.54e917aef5a404ccae2f7db8827e6365.svg";
export { ForwardRef as ReactComponent };